import { render, staticRenderFns } from "./DefaultForm.vue?vue&type=template&id=0a32c87c&scoped=true&"
import script from "./DefaultForm.vue?vue&type=script&lang=js&"
export * from "./DefaultForm.vue?vue&type=script&lang=js&"
import style0 from "./DefaultForm.vue?vue&type=style&index=0&id=0a32c87c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a32c87c",
  null
  
)

export default component.exports